import type { FC } from "react";

import clsx from "clsx";

const Card: FC<{ red?: boolean }> = ({ red }) => (
	<div className={clsx("rounded-[2px] h-4 w-3", red ? "bg-red-500" : "bg-yellow-400")} />
);

export default Card;
